module.exports = __webpack_public_path__ + "static/media/natuera_favicon.4d6e45fd.ico";